import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getUserRole, isAuthenticated } from 'selectors/user/session'
import { Actions as AuthenticationActions } from 'actions/authentication'
import type { Modals } from 'types/Authentication'
import { Actions } from 'actions/shared/modal'
import { Actions as FlashMessageActions } from 'actions/shared/flashMessage'
const mapStateToProps = createStructuredSelector({
  userRole: getUserRole,
  isAuthenticated,
})

const mapDispatchToProps = (dispatch) => ({
  showModal: (payload: Modals) => dispatch(AuthenticationActions.SHOW_MODAL(payload)),
  addMessage: (message, type) => {
    dispatch(
      FlashMessageActions.ADD({
        messages: [message],
        type: type || 'error',
      })
    )
  },
  openModal: (payload: string) => dispatch(Actions.OPEN_MODAL(payload)),
  closeModal: () => dispatch(Actions.CLOSE_MODAL()),
})

export type ConnectorProps = {
  userRole: string
  isAuthenticated: boolean
  showModal: (...args: Array<any>) => any
  addMessage: (...args: Array<any>) => any
  openModal: (...args: Array<any>) => any
  closeModal: (...args: Array<any>) => any
}
export default connect(mapStateToProps, mapDispatchToProps)